var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-empty-home list"},[_c('div',{staticClass:"title-empty-home"},[_vm._v(_vm._s(_vm.$t('empty_home_5')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }